// https://www.npmjs.com/package/@datapunt/matomo-tracker-react
import { createInstance } from '@datapunt/matomo-tracker-react';

const disabled = import.meta.env.VITE_MATOMO_DISABLED === 'true';
const urlBase = import.meta.env.VITE_MATOMO_URL;
const siteId = import.meta.env.VITE_MATOMO_SITE_ID;

const push = (entry) => {
  // The tracker creates the queue only after statistics consent was granted.
  // Do not queue interactions before consent: a non-empty queue also prevents
  // @datapunt/matomo-tracker-js from initializing later.
  if (typeof window === 'undefined' || !window._paq) {
    return;
  }
  window._paq.push(entry);
};

export const trackError = (e, cat = null) => {
  if (cat) {
    push(['CrashAnalytics::trackJsError', e, cat]);
  } else {
    push(['CrashAnalytics::trackJsError', e]);
  }
};

export const trackEvent = (category, action, name, value = null) => {
  if (value) {
    push(['trackEvent', category, action, name, value]);
  } else {
    push(['trackEvent', category, action, name]);
  }
}

export const trackGoal = (id, value = null) => {
  if (value) {
    push(['trackGoal', id, value]);
  } else {
    push(['trackGoal', id]);
  }
};

const matomo = () => createInstance({
  urlBase,
  siteId,
  disabled, // optional, false by default. Makes all tracking calls no-ops if set to true.
  // userId: 'UID76903202', // optional, default value: `undefined`.
  // trackerUrl: 'https://LINK.TO.DOMAIN/tracking.php', // optional, default value: `${urlBase}matomo.php`
  // srcUrl: 'https://LINK.TO.DOMAIN/tracking.js', // optional, default value: `${urlBase}matomo.js`
  // heartBeat: { // optional, enabled by default
  //   active: true, // optional, default value: true
  //   seconds: 10 // optional, default value: `15
  // },
  // linkTracking: false, // optional, default value: true
  configurations: { // optional, default value: {}
  //   // any valid matomo configuration, all below are optional
    disableCookies: true,
  //   setSecureCookie: true,
  //   setRequestMethod: 'POST'
  }
});

export default matomo;
